// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goods-attribute-view-form .draggableItem {\n  cursor: pointer;\n}\n.goods-attribute-view-form .draggableItem i {\n  font-size: 18px;\n}\n.goods-attribute-view-form {\n  padding-bottom: 20px;\n}", ""]);
// Exports
module.exports = exports;
